import React from "react";
import PropTypes from "prop-types";
import { useTrackElement } from "@edreamsodigeo/frontend-core";
import { Body, Box, Flex, Glyph } from "@edreamsodigeo/prisma-design-system";

const ModalMessage = ({ message, type, trackingId = "" }) => {
  const trackingRef = useTrackElement(["display"], trackingId);
  const typeColor = type === "ERROR" ? "red" : "green";

  return (
    <Box
      {...(trackingId && { ref: trackingRef })}
      py={["base", "1x_small"]}
      px="base"
      borderRadius={1}
      backgroundColor={`${typeColor}.20`}
    >
      <Flex width="100%" justifyContent="center">
        {type !== "ERROR" && (
          <Box minWidth="auto" height="auto" pr="2x_small" display="flex">
            <Glyph
              category="UIActions"
              name="Check"
              size={["small", "medium"]}
              color={`${typeColor}.50`}
            />
          </Box>
        )}
        <Box display="flex">
          <Body
            type={["small", "base"]}
            weight="medium"
            color={`${typeColor}.50`}
          >
            {message}
          </Body>
        </Box>
      </Flex>
    </Box>
  );
};

ModalMessage.propTypes = {
  message: PropTypes.string.isRequired,
  type: PropTypes.oneOf(["OK", "ERROR"]).isRequired,
  trackingId: PropTypes.string,
};

export default ModalMessage;
